import { useInfiniteQuery, useQuery } from '@tanstack/vue-query'
import { getCrudIndexQuery } from '../crud/crud.index.query'
import { API_CUSTOMER_GET } from '~/constants/routes/api/customer/routes.constants'
import type { CustomerAPIInterface, CustomersAPIInterface } from '~/interfaces/api/customer.interfaces'
import { getCustomersRepository } from '~/repository/customer/customer.repository'

export const getCustomerInfiniteQuery = (name?: Ref<string | undefined>) => {
  return useInfiniteQuery({
    queryKey: ['customersInfiniteQuery', name],
    refetchInterval: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchIntervalInBackground: false,
    queryFn: async ({ pageParam = 1 }): Promise<Ref<CustomersAPIInterface | null>> => {
      const query = {
        page: pageParam,
        limit: 900
      }

      if (name?.value !== undefined) {
        Object.assign(query, {
          'filters[search]': name.value
        })
      }

      const { data } = await useFetchAPI<CustomersAPIInterface>(API_CUSTOMER_GET.path, {
        query
      })

      return data
    },
    getNextPageParam: (lastPage) => {
      if (lastPage.value?.pagination?.current_page !== undefined) {
        return lastPage.value?.pagination?.current_page + 1
      }
      return 0
    }
  })
}

export const getCustomers = (page: Ref<number>, limit: Ref<number>, name?: Ref<string | undefined>, status?: Ref<number>, enabled?: Ref<boolean>) => {
  return getCrudIndexQuery<CustomersAPIInterface>(
    page,
    limit,
    'customers',
    () => getCustomersRepository(page.value, limit.value, name?.value, status?.value),
    [name, status, enabled],
    enabled
  )
}

export const getCustomersActiveOnly = (page: Ref<number>, limit: Ref<number>, name?: Ref<string | undefined>, status?: Ref<number>, enabled?: Ref<boolean>) => {
  return getCrudIndexQuery<CustomersAPIInterface>(
    page,
    limit,
    'customers-activeOnly',
    () => getCustomersRepository(page.value, limit.value, name?.value, status?.value, 1),
    [name, status, enabled],
    enabled
  )
}

export const getCustomer = (id: Ref<number>) => {
  return useQuery({
    queryKey: ['customer', id],
    retry: false,
    queryFn: async (): Promise<CustomerAPIInterface> => {
      return await useCustomFetch<CustomerAPIInterface>(`${API_CUSTOMER_GET.path}/${id.value.toString()}`)
    }
  })
}
